import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getConfigByCode } from 'y4/Falcon';
import { useLocation, useParams } from 'react-router-dom';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { postToTask } from 'y4/Y4Api';
import y from 'y4/Utils';

const Shortener = () => {
  const { t } = useTranslation('shortener');
  const location = useLocation();
  let params = useParams();

  const [link, setLink] = useState({
    title: t('Loading....'),
    description: t('Url is still loading, please wait')
  });

  useEffect(() => {
    if (y.include(params.id, '$')) {
      postToTask('TASK_Shortener_Parse', params).then(rt => {
        console.log(rt);
        if (rt.isOk()) {
          let to = rt.data.url;
          if (location.search) {
            const flag = to.includes('?') ? '&' : '?';
            to = to + flag + location.search.slice(1);
          }
          window.location.replace(to);
        } else {
          setLink({
            title: t('404'),
            description: rt.message || t('The url no longer exists')
          });
        }
      });
    } else {
      getConfigByCode(params.id, 'Shortener').then(cs => {
        if (_.isEmpty(cs)) {
          setLink({
            title: t('404'),
            description: t('The url no longer exists')
          });
        } else {
          let to = cs[0].url;
          if (to) {
            if (location.search) {
              const flag = to.includes('?') ? '&' : '?';
              to = to + flag + location.search.slice(1);
            }
            if (_.startsWith(to, 'http')) {
              window.location.replace(to);
            } else {
              //navigate(to, { replace: true });
              //使用 navigate 不会执行 Falcon.init，也不会显示 cron 对应的网页标题
              window.location.replace(to);
            }
          } else {
            setLink({
              title: t('404'),
              description: t('The url no longer exists')
            });
          }
        }
      });
    }
  }, []);

  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">
          <Link className="text-white text-decoration-underline" to="/">
            {t('Take me home')}
          </Link>
        </p>
      }
    >
      <h5 className="mb-0 mt-1">{link.title}</h5>
      <div className="pt-3">{link.description}</div>
    </AuthCardLayout>
  );
};

export default Shortener;
